export * from '@macs-frontend/core/base';
export { CoreModule } from '@macs-frontend/core/core.module';
export * from '@macs-frontend/core/environments/environment';
export * from '@macs-frontend/core/services';
